import { createAction } from '@reduxjs/toolkit';

export const resetPostponeInvoice = createAction('INVOICE_RESET_POSTPONE');
export const setPostponeRejectionCode = createAction<{ errorCode: string; errorCodeShortHand: string }>(
  'INVOICE_SET_REJECTION_STATE',
);
export const setLoadedInvoicesFrom = createAction<number>('INVOICE_SET_LOADED_INVOICES_FROM');
export const setInvoicePdfErrorCode = createAction<string>('INVOICE_SET_PDF_ERROR');
